import axios from 'axios'

export class Http {
  constructor({ baseURL } = {}) {
    this.instance = axios.create({ baseURL })
    return this.instance
  }
}
